import React from 'react';
import { Button } from 'react-bootstrap';
import { BrowseContactLink, BrowseTypePill } from '../browse/BrowseContactLink';
import { externalDisplayName } from '../browse/browseFormatters';

export default function ExternalMembersListRows({ items, onEdit, onDelete }) {
  return items.map((m) => {
    const fullName = externalDisplayName(m);

    return (
      <article key={m.id} className="recv-browse-row recv-browse-row--external" role="listitem">
        <div className="recv-browse-list__cell recv-browse-list__cell--lead">
          <div className="recv-browse-row__identity">
            <div className="recv-browse-row__title" title={fullName}>
              {fullName}
            </div>
            <div className="recv-browse-row__meta-line">
              <BrowseTypePill tone="external">{m.statut || 'EXTERNE'}</BrowseTypePill>
            </div>
          </div>
        </div>
        <div className="recv-browse-list__cell recv-browse-list__cell--contact">
          <span className="recv-browse-row__label">Contact</span>
          <div className="recv-browse-row__contact-stack">
            <BrowseContactLink kind="phone" value={m.telephone} />
            <BrowseContactLink kind="mail" value={m.email} />
          </div>
        </div>
        <div className="recv-browse-list__cell recv-browse-list__cell--action">
          <span className="recv-browse-row__label">Actions</span>
          <div className="recv-browse-row__actions">
            <Button
              size="sm"
              variant="outline-primary"
              className="recv-browse-action-btn"
              onClick={() => onEdit?.(m)}
            >
              Modifier
            </Button>
            <Button
              size="sm"
              variant="outline-danger"
              className="recv-browse-action-btn"
              onClick={() => onDelete?.(m)}
            >
              Supprimer
            </Button>
          </div>
        </div>
      </article>
    );
  });
}
